'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _Select = require('../../inputs/Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function FieldSelect(props) {
  var style = props.style,
      passing = _objectWithoutProperties(props, ['style']);

  return _react2.default.createElement(
    'div',
    { className: style.searchBar },
    _react2.default.createElement(_Select2.default, _extends({
      multi: true,
      placeholder: '\u9078\u64C7\u641C\u5C0B\u6B04\u4F4D'
    }, passing))
  );
}
FieldSelect.propTypes = {
  value: _propTypes.array,
  onChange: _propTypes.func.isRequired,
  options: _propTypes.array.isRequired,
  formatter: _propTypes.func.isRequired,
  style: _propTypes.object.isRequired
};

exports.default = FieldSelect;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/FieldSelect/FieldSelect.js
// module id = 1680
// module chunks = 0